export default __webpack_public_path__ + "06b6f982.jpg";